import { Button, Divider } from 'antd';
import { SupplementKnowledgeChatPanel } from '../Detail/ChatPanel';
import { EmptyKnowledgePlaceholder } from '../Detail/EmptyKnowledgePlaceholder';
import { ContentWithDetailProps } from './ContentWithDetail';
import { QAInfo } from './QAInfo';
import { useTranslate } from '@tolgee/react';

export const ContentWithNotSupport = (
  props: ContentWithDetailProps & { hideChatPanel?: boolean },
) => {
  const {
    conversation,
    dataSource,
    onRefresh,
    onClose,
    onDelayRefresh,
    hideChatPanel = false,
  } = props;
  const { supplementalKnowledgeValue } = dataSource;
  const { originQuestions } = supplementalKnowledgeValue;
  const { t } = useTranslate();

  return (
    <div className="w-full h-full flex relative">
      {!hideChatPanel && (
        <SupplementKnowledgeChatPanel
          dataSource={dataSource}
          onRefresh={onRefresh}
          onDelayRefresh={onDelayRefresh}
          showExpandSkuButton={false}
        />
      )}
      <div className="flex-1 h-full bg-[var(--fett-bg-elevated)] relative flex flex-col pt-[6px] pb-[72px] overflow-hidden">
        <QAInfo conversation={conversation} dataSource={dataSource} onRefresh={onRefresh} />
        <Divider dashed className="!my-4" />
        <EmptyKnowledgePlaceholder question={originQuestions?.[0]} conversation={conversation} />
        <div className="absolute bottom-0 left-0 right-0 w-full h-[56px] px-4 bg-[var(--fett-bg-elevated)] shadow flex items-center justify-end gap-4">
          <Button onClick={onClose}>{t('退出')}</Button>
        </div>
      </div>
    </div>
  );
};
